<template>
	<div class="pages">
		<section class="fx filter-wapper">
			<div class="fx fx-wrap fx-fill">
				<div class="fx fx-wrap m-l-10">
					<el-date-picker
				      v-model="params.orderTime"
				      type="daterange"
				      align="left"
				      placeholder="选择日期范围"
				      @change="handleShowList">
				    </el-date-picker>
				</div>
			</div>
			<div class="fx-shrink"><z-search v-model="params.search" placeholder="卡号 / 手机号" @handleSearch="handleOffset(0)"></z-search></div>
			
		</section>
		<z-table :offset="params.offset" :count="params.count" :total-count="result.total_count" @handleOffset="handleOffset">
			<th slot="columns" v-for="(index, item) in columns">
				{{index}}
				<a 
					v-if="item==4"
					:class="[params.orderBy=='score:ASC'?'up-sort':params.orderBy=='score:DESC'? 'down-sort':'']"
					class="arrow m-l-5"
					@click="handleListByOrder('score')">
				</a>
			</th>
			<tr slot="datasource" v-for="item in result.list">
				<td>
					<img :src="item.headimgurl || '../../../../public/logo_def.png'"/>
					<!--<span v-if="item.headimgurl">
						<z-img-hover :src="item.headimgurl" width="60"></z-img-hover>
					</span>
					<span v-else>
						<z-img-hover src="../../../../public/logo_def.png" width="60"></z-img-hover>
					</span>-->
				</td>
				<td>{{item.nickname || "-"}}</td>
				<td>{{item.code}}</td>
				<!--<td>{{item.telphone}}</td>-->
				<td>{{item.score}}</td>
				<!--<td>{{item.status | cardStatus}}</td>-->
				<td>{{item.last_time | momentFmt}}</td>
				<!--<td class="operating">
					<a class="operat-btn"><i class="icon-look"></i><span>详情</span></a>
				</td>-->
			</tr>
			<!--<tr slot="datasource" v-if="result.list.length <= 0">
				<td colspan="20"><p class="p-20">暂无记录 (˘•ω•˘)</p></td>
			</tr>-->
		</z-table>
	</div>
</template>
<style scoped lang="scss">
	@import "src/assets/css/common.scss";
	table img{
		width: 50px;
	}
	.arrow{
		position: relative;
		&:before,&:after{
			content: "";
			position: absolute;
			width: 0;
			height: 0;
		}
		&:before{
			border-left: 3px solid transparent;
		    border-right: 3px solid transparent;
		    border-bottom: 6px solid $color-border;
		    top: -0;
		    left: 0;
		}
		&:after{
			border-left: 3px solid transparent;
		    border-right: 3px solid transparent;
		    border-top: 6px solid $color-border;
		    bottom: -0px;
		    left: 0;
		}
		&.up-sort{
			&:before{
				border-bottom-color: $color-main;
			}
		}
		&.down-sort{
			&:after{
				border-top-color: $color-main;
			}
		}
	}
	@media only screen and (min-width:0px) and (max-width:640px) {
		.pages{
			min-width: px-em(1100px);
		}
	}
</style>
<script>
	import { mapState,mapActions } from 'vuex';
	export default {
		name: 'VipManage',
		components: {
		},
		data() {
			return {
				columns :['会员头像','会员姓名','卡号','积分', '领取时间'],
				value:"",
				
				params: {
					offset: 0, //分页偏移量
					count: 10, //每页多少条
					serach: '',
					orderBy: "create_time:DESC",
					orderTime: ''
				},
//				memberList: []
				result: {
					list: [],
					item_count: 0,
					total_count: 0
				},
				flag: true,
			}
		},
		filters: {
			cardStatus(status) {
				switch(status) {
					case 1:
						return '待使用';
						break;
					case 2:
						return '已使用';
						break;
					default:
						return '待使用';
						break;
				}
			}
		},
		computed: {
			...mapState({
				list: state => state.vipCard.memberCard
			})
		},
		mounted() {
			this.handleGetMemberList();
		},
		methods: {
			handleShowList() {
				this.handleOffset(0);
			},
			
			//处理分页
			handleOffset(offset) {
				this.params.offset = offset;
				this.handleGetMemberList();
			},
			
			//排序
			handleListByOrder(orderBy) {
				if (this.params.orderBy == 'score:DESC') {
					this.params.orderBy = orderBy + ':ASC';
				} else {
					this.params.orderBy = this.params.orderBy == orderBy + ':ASC' ? orderBy + ':DESC' : orderBy + ':ASC';
				}
				this.params.offset = 0;
				this.handleGetMemberList();
			},
			
			handleGetMemberList() {
				this.showVipMemberCardList(this.params).then((data)=>{
					this.result = data;
					this.$log('获取会员列表成功');
				},(msg)=>{
					this.$toast(msg);
				})
			},
			
			...mapActions(['showVipMemberCardList']),
	    }
	}
</script>



// WEBPACK FOOTER //
// VipMember.vue?0ee6687a